import $ from 'jquery';

$.tag = (name, attrs, content) => {
  const t = ['<', name];
  $.each(attrs, function (k, v) {
    if (v !== null) {
      t.push(
        [
          ' ',
          k.replace(/"/g, '\x26quot;'),
          '="',
          `${v}`.replace(/"/g, '\x26quot;'),
          '"',
        ].join(''),
      );
    }
  });
  if (content === undefined) {
    t.push(['></', name, '>'].join(''));
  } else if (!content) {
    t.push(' />');
  } else {
    t.push(['>', content, '</', name, '>'].join(''));
  }
  return t.join('');
};
